export const getServiceTypeAsString = (type) => {
    if (!type) return

    return type['type']
};

export const isLegalAdviser= (vertical) => {
    return vertical === 'legal_adviser';
};